import { Component, OnInit } from '@angular/core';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-visa-click-to-pay',
  templateUrl: './visa-click-to-pay.component.html',
  styleUrls: ['./visa-click-to-pay.component.scss']
})
export class VisaClickToPayComponent implements OnInit {
  constructor(private sessionService:SessionService) { }

  ngOnInit(): void {
  }

  toggleListView(){
    this.sessionService.emitPaymentMethodPromotion("visa-click-to-pay");
  }
}
